


















import { Vue, Component } from "vue-property-decorator";
import { bus } from "../../main";
@Component
export default class LoadingDialog extends Vue {
	private loadingDialog: boolean;
	constructor() {
		super();
		this.loadingDialog = false;
	}

	created() {
		bus.$on("startLoading", () => {
			this.loadingDialog = true
		});

		bus.$on("stopLoading", () => {
			this.loadingDialog = false
		});
	}
}
